import {get, filter} from "lodash"

export function isSingleProductOnly(deal) {
  const products = get(deal, "productConfig.products", [])
  const numberOfItems = get(deal, "productConfig.limits.perRedemption.numberOfItems", false)

  return products.length === 1 && numberOfItems === 1
}

export const productItemLimit = (deal) => {
  const limit = get(deal, "productConfig.limits.perRedemption.numberOfItems", 1)

  // if unset, assume unlimited
  if (limit === null) {
    return 9999
  }

  return limit
}

export const productsLimit = (deal) => {
  const limit = get(deal, "productConfig.limits.perRedemption.numberOfProducts", 1)

  // if unset, assume unlimited
  if (limit === null) {
    return 9999
  }

  return limit
}

export const productCount = (deal) => {
  const count = get(deal, "productConfig.products.length", 0)

  return count
}

export const hasCinemaProduct = (deal) => {
  let isCinema = false
  deal.productConfig.products.forEach((product) => {
    if (product.data.cinemaMetadata.enabled) {
      isCinema = true
    }
  })

  return isCinema
}

export const productsInStock = (deal, stock) => {
  const products = deal.productConfig.products.map((product) => {
    if (stock[product.uuid] > 0) {
      return product
    }
  })

  return filter(products, (product) => !!product)
}

export const isPaymentRequired = (deal) => {
  let isRequired = false

  deal.productConfig.products.forEach((product) => {
    const price = get(product, "salePrice.value", null)

    if (price) {
      isRequired = true
    }
  })

  return isRequired
}
